export enum TimeUnit {
  DAY = 'day',
  HOUR = 'hour',
}
